<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container>
      <v-row class="mb-4" align="center">
        <v-col cols="auto">
          <h2 v-if="diagnosisData">
            {{ $t("basics.edit", { type: $t("routes.diagnosis") }) }}
          </h2>
          <h2 v-else>
            {{ $t("basics.new", { type: $t("routes.diagnosis") }) }}
          </h2>
        </v-col>
      </v-row>

      <v-form ref="diagnosisEditForm">
        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat :rules="[requiredRule, max256]" v-model="name"
              :label="$t('basics.name') + '*'" :readonly="readonly"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat :rules="[requiredRule, max20]" v-model="number"
              :label="$t('basics.number') + '*'" :readonly="readonly"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-textarea variant="outlined" flat :rules="[]" v-model="comment" :label="$t('basics.comment')"
              :readonly="readonly"></v-textarea>
          </v-col>
        </v-row>


        <v-row>
          <v-col cols="12">
            <v-checkbox class="hideDetails" :label="$t('messages.defaultBillDiagnosis')" :readonly="readonly"
              v-model="defaultBill">
            </v-checkbox>
          </v-col>
        </v-row>


        <v-row v-if="!readonly">
          <v-col cols="12">
            <v-btn large block flat class="primaryButton" @click="confirm()" ref="confirmButton" style="width: 100%">
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "diagnosisEditDrawer",
  props: ["diagnosisData", "refreshDisplay", "readonly"],
  emits: ["close"],

  data() {
    return {
      name: undefined,
      number: undefined,
      comment: undefined,
      defaultBill: false,

      requiredRule: (value) => !!value || this.$i18n.t("messages.required"),
      max256: (value) =>
        !value || value.length <= 256 || this.$i18n.t("messages.tooLong", { count: 256 }),
      max20: (value) =>
        !value || value.length <= 20 || this.$i18n.t("messages.tooLong", { count: 20 }),
      max5000: (value) =>
        !value ||
        value.length <= 5000 ||
        this.$i18n.t("messages.tooLong", { count: 5000 }),
    };
  },

  components: {
  },

  watch: {
    refreshDisplay() {
      this.setValues();
    },
  },

  methods: {
    async confirm() {
      const { valid } = await this.$refs.diagnosisEditForm.validate();

      if (valid) {
        let formData = {};
        formData.name = this.name;
        formData.number = this.number;
        formData.comment = this.comment;
        formData.default_bill = this.defaultBill

        if (this.diagnosisData) {
          formData.id = this.diagnosisData.id;
          this.patchData(formData);
        } else {
          this.postData(formData);
        }
      }
    },
    postData(formData) {
      this.axios
        .post(this.axios.defaults.baseURL + "media/diagnosis/post/", formData)
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },

    patchData(formData) {
      this.axios
        .patch(
          this.axios.defaults.baseURL + "media/diagnosis/patch/" + formData.id,
          formData
        )
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    setValues() {
      if (this.diagnosisData) {
        this.name = this.diagnosisData.name;
        this.number = this.diagnosisData.number;
        this.comment = this.diagnosisData.comment;
        this.defaultBill = this.diagnosisData.default_bill
      } else {
        this.name = undefined;
        this.number = undefined;
        this.comment = undefined;
        this.defaultBill = undefined
      }
    },
  },

  mounted() { },
};
</script>
